export enum VersionGame {
  NinthAge = 'ninthAge',
  WarhammerBattle = 'battle',
  EssenceOfWar = 'essenceOfWar',
  TheOldWorld = 'theOldWorld',
}
